import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Setting } from '../../../../../../models/settings';
import { SettingService } from '../../../../../../services/setting.service';

@Component({
    selector: 'app-update-setting',
    templateUrl: './update-setting.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateSettingComponent extends BaseComponent implements OnInit {
    setting: Setting = new Setting();

    constructor(
        private settingService: SettingService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.setting.key = route.snapshot.params['id'];
    }

    ngOnInit() {
        this.getSetting();
    }

    getSetting() {
        Helpers.setLoading(true);
        this.settingService.find(this.setting.key).subscribe(res => {
            this.setting = res.data;
            Helpers.setLoading(false);
        });
    }

    validate(event) {
        return this.validationService.validate(event, {
            rules: {
                value: { required: true }
            }
        });
    }

    updateSettings() {
        var _self = this;
        Helpers.setLoading(true);
        this.settingService.update(this.setting).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.router.navigate(['/owner/setting/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/setting/update-setting/update-setting.component.ts